import LibraryIcon from '@atlaskit/icon/core/library';
import * as React from 'react';

export function SvgVideoLibrary() {
  return <LibraryIcon label="" testId="ads-refreshed-icon" />;
}
